import Vue from 'vue'
import Router from 'vue-router'

import pagesRouting from '@pages/pages-routing'
import authRouting from '@auth/auth-routing'
import mineRouting from '@mine/mine-routing'

import {wrapperRouter} from '@utils'
import _ from 'lodash'
import { isLeYou } from './shared/utils/constant'

Vue.use(Router)

@wrapperRouter
class RouterClazz extends Router{
  constructor(...args){
    super(...args);
  }
}

const router = new RouterClazz({
  mode: 'history',
  base: isLeYou? '/open' :'/',
  routes: [
    ...pagesRouting,
    ...authRouting,
    ...mineRouting
  ]
})

router.beforeEach((to, from, next) => {
  let fromSource = _.get(from, ['query', 'source'])
  let toSource = _.get(to, ['query', 'source'])
  if (toSource === 'ncsupplier-portal') {
    next()
  } else if (fromSource === 'ncsupplier-portal') {
    let toQuery = JSON.parse(JSON.stringify(to.query))
    toQuery.source = fromSource
    next({
      path: to.path,
      query: toQuery
    })
  } else {
    next()
  }
})

export default router
